import { ArrowUpRight } from "@phosphor-icons/react";
import { AMENITIES } from "@/lib/data";
import { SectionHeading } from "@/components/SectionHeading";

export const AmenitiesBento = () => {
  return (
    <section
      data-testid="amenities-bento"
      className="py-24 md:py-32 px-6 md:px-10 bg-brand-ivory"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <SectionHeading
            overline="Amenities"
            title={
              <>
                Living, reimagined.
                <br />
                <span className="italic text-brand-gold">Eighteen world-class amenities.</span>
              </>
            }
            lead="From the rooftop infinity pool to the Aristotle Digital Library — every square foot of Exente is designed for community."
            testId="amenities-heading"
          />
          <a
            href="/amenities"
            data-testid="amenities-view-all"
            className="inline-flex items-center gap-2 text-brand-forest font-medium border-b border-brand-gold pb-1 hover:gap-3 transition-all"
          >
            View all amenities <ArrowUpRight size={18} weight="light" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 auto-rows-[220px] md:auto-rows-[260px]">
          {AMENITIES.map((a, i) => (
            <article
              key={a.title}
              data-testid={`amenity-card-${i}`}
              className={`relative group overflow-hidden rounded-2xl border border-brand-sage bg-brand-sage/30 ${a.span}`}
            >
              <img
                src={a.image}
                alt={a.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-forest/90 via-brand-forest/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
                <h3 className="font-display text-2xl md:text-3xl text-brand-ivory">{a.title}</h3>
                <p className="text-sm text-brand-ivory/85 mt-2 max-w-md leading-relaxed">
                  {a.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
